import React, { useState } from 'react'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { PDFReader } from 'reactjs-pdf-reader'

interface PdfPreviewProps {
  file: File
}

type base64Type = string | ArrayBuffer | null

const PdfPreview = ({ file }: PdfPreviewProps): JSX.Element => {
  const [base64, setBase64] = useState<base64Type>(null)

  const fileReader = new FileReader()
  fileReader.onload = function (fileLoadedEvent) {
    const binaryData = fileLoadedEvent.target
      ? fileLoadedEvent.target.result
      : ''
    setBase64(binaryData)
  }
  fileReader.readAsDataURL(file)

  return (
    <React.Fragment>
      {base64 && <PDFReader url={base64} scale={0.5} />}
    </React.Fragment>
  )
}

export default PdfPreview
